import { MobileAppReferer } from 'utils/MobileAppReferer';

export function useMobileAppReferer(): null | MobileAppReferer {
  const referer = new URLSearchParams(window.location.search).get('referer');

  if (referer === MobileAppReferer.REFERER_PARAM_VALUE) {
    return new MobileAppReferer();
  }

  return null;
}
